import React from "react";
import Button from "Components/button/Button";
import CustomerSelect from "Components/customerSelect/CustomerSelect";
import TranslatedString from "Components/TranslatedString";
import WarningBanner from "Components/warningBanner/WarningBanner";

import t from "Utils/translation";
import cx from "classnames";
import s from "./ownerDomains.scss";

export default class Owner extends React.Component {
  state = {
    viewFields: ["customer_code"],
  };

  updateCustomerCode = (selectedCustomer) => {
    this.props.setFormFieldValue({ customer_code: selectedCustomer?.value });
  };

  componentWillUnmount() {
    this.props.resetFields(...this.state.viewFields);
  }

  render() {
    const { formErrors, formData, isFormLoading, setFormFieldValue, submitForm } = this.props;

    return (
      <form className={s.registry} method="post" onSubmit={(e) => submitForm(e, this.state.viewFields)}>
        <div className={s.wrapInfoBtn}>
          <div className={s.warnignMsg}>
            {!this.props.areFieldsPristine(...this.state.viewFields) && (
              <WarningBanner color="yellow-text" msg={<TranslatedString>infoMsg.unsaveChanged</TranslatedString>} />
            )}
          </div>

          <div className={s.infoBtnGroup}>
            <Button docsKey="domains_settings" color="docs" type="button">
              button.docs
            </Button>
            <Button type="submit" loading={isFormLoading}>
              button.save
            </Button>
          </div>
        </div>

        <div className={s.settings}>
          <div className="sectionSP">
            <div className="infoSectionSP">
              <div className="settingTitle">{t("settings.sections.registryCompany.title")}</div>
              <div className="sectionDesc" />
            </div>
            <div className="formsSectionSP">
              <CustomerSelect
                className="inputFull2"
                value={formData.customer_code}
                initialValue={formData.customer_code}
                onChange={this.updateCustomerCode}
                errors={formErrors.customer_code}
                name="customer_code"
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}
